import React from 'react';

export type SiteSelectorPopOverProps = {
    title: string;
    children: React.ReactNode;
    onClick?: () => void;
};
export const SiteSelectorButton = ({ children, title, onClick }: SiteSelectorPopOverProps) => {
    return (
        <button className="group relative min-h-[3.5rem] flex-1 overflow-hidden rounded-xl cursor-pointer aspect-[150/64]" onClick={onClick}>
            {children}
            <div className="absolute inset-0 bg-black/[0.35]" />
            <div className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-white">{title}</div>
        </button>
    );
};
